import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  successfulLabelTitle: {
    description: 'returns.returnLabelSuccessTitle',
    defaultMessage: 'Email Sent',
    id: 'QlELZz',
  },
  labelsProcessedSuccessfully: {
    description: 'returns.returnLabelEmailSuccessful',
    defaultMessage: 'Return labels emailed successfully',
    id: 'uIF87L',
  },
  failedLabelTitle: {
    description: 'returns.returnLabelFailedTitle',
    defaultMessage: 'One or more emails failed to send',
    id: 'BRoAUA',
  },
  voidSuccessful: {
    description: 'returns.returnVoidSuccessful',
    defaultMessage: 'Return Voided Successfully',
    id: 'bdSTZ8',
  },
  voidFailure: {
    description: 'returns.returnVoidFailure',
    defaultMessage: 'Return Voided Unsuccessfully',
    id: 'QYxoji',
  },
  returnsExportCompleteTitle: {
    description: 'Title for returns export complete notification',
    defaultMessage: 'Returns Export Ready for Download',
    id: 'KA40G0',
  },
  returnsExportCompleteBody: {
    description: 'Body for returns export complete toast notification',
    defaultMessage: 'Your returns export is ready. A download should have started automatically.',
    id: 'ENovpg',
  },
  searchTermTooShort: {
    description: 'returns.searchTermTooShort',
    defaultMessage: 'Search term should be at least {minLength} characters long',
    id: 'zApPk4',
  },
});
